import breakIntoParagraphs from './breakIntoParagraphs';

export default (params) => {
  const { fieldData, updateVersion } = params;

  const {
    document: { nodes: documentNodes },
  } = fieldData;

  const [letterBodyNodes] = documentNodes;

  const { nodes: inlineNodes } = letterBodyNodes;

  const updatedLetterBodyNodes = [];

  inlineNodes.forEach((node) => {
    const { nodes, type } = node;
    if (type !== 'paragraph') {
      updatedLetterBodyNodes.push(node);
      return;
    }
    if (type === 'paragraph') {
      const [textNode] = nodes;
      if (!textNode) return;
      const text = textNode?.leaves?.map((leaf) => leaf?.text).join('') || '';

      const paragraphs = breakIntoParagraphs(text);

      if (paragraphs?.length === 0) {
        updatedLetterBodyNodes.push({
          object: 'block',
          type: 'paragraph',
          nodes: [
            {
              object: 'text',
              leaves: [
                {
                  object: 'leaf',
                  text: '',
                  marks: [],
                },
              ],
            },
          ],
        });
      }

      paragraphs?.forEach((paragraph) => {
        updatedLetterBodyNodes.push({
          object: 'block',
          type: 'paragraph',
          nodes: [
            {
              object: 'text',
              leaves: [
                {
                  object: 'leaf',
                  text: paragraph.trim(),
                  marks: [],
                },
              ],
            },
          ],
        });
      });
    }
  });

  const updatedLetterBody = {
    object: 'value',
    document: {
      object: 'document',
      data: {
        version: {
          number: updateVersion,
          updated: true,
        },
      },
      nodes: [
        {
          object: 'block',
          type: 'letter_body',
          nodes: updatedLetterBodyNodes,
        },
      ],
    },
  };
  return { letterBody: updatedLetterBody };
};
